import { put, call } from 'redux-saga/effects';
import { 
  updateProfileService,
  saveSecondaryDistrictsService,
  changePwdService,
  resetPwdService,
  forgotPwdService,
  deregisterAdminService,
  fetchAllAdminService
} from '../services/adminService';

import * as types from '../actions'

export function* updateProfileSaga(payload) {
  try {
    const response = yield call(updateProfileService, payload);
    yield put({ type: types.UPDATE_PROFILE_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.UPDATE_PROFILE_ERROR, error })
  }
}

export function* saveSecondaryDistrictsSaga(payload) {
  try {
    const response = yield call(saveSecondaryDistrictsService, payload);
    yield put({ type: types.SAVE_SECONDARY_DISTRICTS_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SAVE_SECONDARY_DISTRICTS_ERROR, error })
  }
}

export function* changePwdSaga(payload) {
  try {
    const response = yield call(changePwdService, payload);
    yield put({ type: types.CHANGE_PASSWORD_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.CHANGE_PASSWORD_ERROR, error })
  }
}

export function* resetPwdSaga(payload) {
  try {
    const response = yield call(resetPwdService, payload);
    yield put({ type: types.RESET_PASSWORD_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.RESET_PASSWORD_ERROR, error })
  }
}

export function* forgotPwdSaga(payload) {
  try {
    const response = yield call(forgotPwdService, payload);
    yield put({ type: types.FORGOT_PASSWORD_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.FORGOT_PASSWORD_ERROR, error })
  }
}

export function* deregisterAdminSaga(payload) {
  try {
    const response = yield call(deregisterAdminService, payload);
    yield put({ type: types.DEREGISTER_ADMIN_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.DEREGISTER_ADMIN_ERROR, error })
  }
}

export function* fetchAllAdminSaga(payload) {
  try {
    const response = yield call(fetchAllAdminService, payload);
    yield put({ type: types.FETCH_ALL_ADMIN_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.FETCH_ALL_ADMIN_ERROR, error })
  }
}